/* Mobellia — wishlist (built by ovanap.dev team).
 * Demo-grade wishlist via localStorage (no app). Toggles products in/out, fills
 * the heart, persists across pages, and renders the Ønskeliste page. A persistent
 * cross-device wishlist would need an app (see pre-launch list).
 */
(function () {
  var KEY = 'mobellia:wishlist';
  var CLOSE = '<svg class="m-svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
  var CHECK = '<svg class="m-svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(l) { try { localStorage.setItem(KEY, JSON.stringify(l.slice(0, 100))); } catch (e) {} document.dispatchEvent(new CustomEvent('mobellia:wishlist:change')); }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) { var l = read(); var i = l.indexOf(h); if (i > -1) l.splice(i, 1); else l.unshift(h); write(l); return l.indexOf(h) > -1; }

  function setState(btn, on) {
    btn.classList.toggle('is-saved', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  function reflect(scope) {
    (scope || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      setState(b, has(b.getAttribute('data-product-handle')));
    });
    updateCount();
  }
  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  function bind(scope) {
    (scope || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      if (b.dataset.wlReady) return;
      b.dataset.wlReady = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var h = b.getAttribute('data-product-handle');
        if (!h) return;
        setState(b, toggle(h));
      });
    });
  }

  /* ---- Ønskeliste page ---- */
  function money(c) { var n = Math.round((c || 0) / 100); return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr'; }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function imgUrl(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=540'; }
  // Add-to-cart straight from the card. Single-variant products add instantly;
  // products with options (size/fabric/side) link to the PDP so the buyer still
  // chooses the right variant — never silently add a default size for furniture.
  function addAction(p) {
    var vs = p.variants || [];
    if (vs.length === 1) {
      if (vs[0].available) return '<button type="button" class="m-btn m-wl__add" data-wl-add data-variant-id="' + vs[0].id + '">Legg i kurv</button>';
      return '<button type="button" class="m-btn m-wl__add" disabled>Utsolgt</button>';
    }
    if (p.available) return '<a href="' + p.url + '" class="m-btn m-btn--outline m-wl__add">Velg variant</a>';
    return '<button type="button" class="m-btn m-wl__add" disabled>Utsolgt</button>';
  }
  function card(p) {
    var media = p.featured_image ? '<img src="' + imgUrl(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
    var price = (p.compare_at_price && p.compare_at_price > p.price)
      ? '<span class="m-price"><span class="m-price__compare">' + money(p.compare_at_price) + '</span><span class="m-price__current m-price__current--sale">' + money(p.price) + '</span></span>'
      : '<span class="m-price"><span class="m-price__current">' + money(p.price) + '</span></span>';
    return '<div class="m-card m-wl__card" data-wl-card data-handle="' + esc(p.handle) + '">' +
      '<button type="button" class="m-wl__remove" data-wl-remove aria-label="Fjern fra ønskeliste">' + CLOSE + '</button>' +
      '<a href="' + p.url + '" class="m-card__link"><div class="m-card__media"><div class="m-card__zoom">' + media + '</div></div>' +
      '<div class="m-card__cat">' + esc(p.type || '') + '</div><div class="m-card__name">' + esc(p.title) + '</div>' +
      '<div class="m-card__price">' + price + '</div></a>' +
      '<div class="m-wl__actions">' + addAction(p) + '</div></div>';
  }
  // Update every cart-count badge from the live cart total.
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count; el.hidden = c.item_count === 0;
        });
      }).catch(function () {});
  }
  function bindAdd(grid) {
    grid.querySelectorAll('[data-wl-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        if (!id || btn.disabled) return;
        var orig = btn.innerHTML;
        btn.disabled = true; btn.textContent = 'Legger til …';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () {
            btn.innerHTML = CHECK + '<span>Lagt i kurv</span>';
            refreshCartCount();
            setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1900);
          })
          .catch(function () {
            btn.textContent = 'Prøv igjen'; btn.disabled = false;
            setTimeout(function () { btn.innerHTML = orig; }, 1900);
          });
      });
    });
  }
  function renderPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;
    var grid = root.querySelector('[data-wl-grid]');
    var empty = root.querySelector('[data-wl-empty]');
    var handles = read();
    if (!handles.length) { grid.innerHTML = ''; grid.hidden = true; if (empty) empty.hidden = false; return; }
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      var html = items.filter(Boolean).map(card).join('');
      if (!html) { grid.hidden = true; if (empty) empty.hidden = false; return; }
      if (empty) empty.hidden = true;
      grid.hidden = false;
      grid.innerHTML = html;
      bindAdd(grid);
      grid.querySelectorAll('[data-wl-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var c = btn.closest('[data-wl-card]');
          var h = c.getAttribute('data-handle');
          var l = read(); var i = l.indexOf(h); if (i > -1) { l.splice(i, 1); write(l); }
          c.remove();
          if (!grid.children.length) { grid.hidden = true; if (empty) empty.hidden = false; }
        });
      });
    });
  }

  function init(scope) { bind(scope); reflect(scope); renderPage(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // Bind hearts on cards appended by infinite scroll.
  document.addEventListener('mobellia:products:appended', function () { init(); });
  // Keep all hearts + the page in sync when the list changes in any tab/section.
  document.addEventListener('mobellia:wishlist:change', function () { reflect(); });
})();
